// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD_jTjpp2M2N9jQ1cPilpXuQMG7lsl_UCs",
    authDomain: "unfpa-vr.firebaseapp.com",
    databaseURL: "https://unfpa-vr-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "unfpa-vr",
    storageBucket: "unfpa-vr.appspot.com",
    messagingSenderId: "31587509238",
    appId: "1:31587509238:web:4556cd77cf392f29959dd7",
    measurementId: "G-ZNXZ8H1DKY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const functions = getFunctions(app, "asia-south1")
export const auth = getAuth(app);

export const db = getFirestore(app);